import React from 'react';
import PropTypes from 'prop-types';

import HttpService from 'commonjs-tools/build/http-service';
import config from '../utils/config'

class Inject extends React.Component {
    static propTypes = {
        url: PropTypes.string
    }

    httpService = new HttpService(config.server)

    componentDidMount () {
        this.httpService.get('/externals?url=' + this.props.url).then(data => {
            hydrate(data, this.refs.external)
        })
    }

    render() {
        return <div ref="external"></div>
    }
}

export default Inject;
